import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { db } from '../../firebase'; // Adjust your firebase import path
import { doc, updateDoc, arrayUnion, getDoc } from 'firebase/firestore';

export default function DynamicRating({ productId, initialRating, initialCount, onRatingUpdate }) {
  const [rating, setRating] = useState(initialRating || 0);
  const [reviewCount, setReviewCount] = useState(initialCount || 0);
  const [hover, setHover] = useState(0);
  const [hasRated, setHasRated] = useState(false);

  const handleRate = async (selectedRating) => {
    if (hasRated) return; // Prevent multiple ratings in a single session

    try {
      const productRef = doc(db, 'products', productId);
      
      // Calculate new dynamic average rating
      const newCount = reviewCount + 1;
      const newAverage = Number(((rating * reviewCount + selectedRating) / newCount).toFixed(1));

      // Update Firestore database
      await updateDoc(productRef, {
        rating: newAverage,
        reviewsCount: newCount
      });

      // Update local state
      setRating(newAverage);
      setReviewCount(newCount);
      setHasRated(true);

      if (onRatingUpdate) {
        onRatingUpdate(newAverage, newCount);
      }

      alert(`Thank you for rating this product ${selectedRating} stars!`);
    } catch (error) {
      console.error("Error updating rating:", error);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <div className="flex items-center space-x-0.5">
        {[1, 2, 3, 4, 5].map((star) => {
          const ratingValue = star;
          return (
            <button
              type="button"
              key={star}
              disabled={hasRated}
              className={`focus:outline-none transition-transform ${!hasRated ? 'hover:scale-125 cursor-pointer' : 'cursor-default'}`}
              onClick={() => handleRate(ratingValue)}
              onMouseEnter={() => !hasRated && setHover(ratingValue)}
              onMouseLeave={() => !hasRated && setHover(0)}
            >
              <Star
                className={`h-4 w-4 ${
                  ratingValue <= (hover || rating)
                    ? 'text-amber-500 fill-amber-500'
                    : 'text-gray-300'
                }`}
              />
            </button>
          );
        })}
      </div>
      <span className="text-sm font-bold text-gray-900">{rating}</span>
      <span className="text-xs text-gray-500">({reviewCount} ratings)</span>
      {hasRated && <span className="text-[10px] text-emerald-600 font-bold ml-1">✓ Rated</span>}
    </div>
  );
}